module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Apple-Watch-0575730903cab73683e79052fd00df61.svg";